import PropTypes from "prop-types";
import React from "react";
import { Checkbox } from "@opendate-app/setlist";
import { backendText, dealType, guaranteeText, offerDate } from "../../ConfirmShow/utils/offerDealSummary";
import "./CopyOffersPicker.css";

const STATE_LABELS = { draft: "Draft", sent: "Sent", accepted: "Accepted" };

const dealTerms = (offer) =>
  [guaranteeText(offer), backendText(offer)].filter((part) => part !== "—").join(" + ") || "—";

const CopyOffersPicker = ({ offers, selectedIds, onChange }) => {
  const allSelected = selectedIds.length === offers.length;
  const toggleOffer = (offerId, checked) =>
    onChange(checked ? [...selectedIds, offerId] : selectedIds.filter((id) => id !== offerId));

  return (
    <div className="copy-offers-picker">
      <div className="copy-offers-picker-title">Copy offers</div>
      <Checkbox
        id="copy-offers-select-all"
        label={`Select all (${selectedIds.length} of ${offers.length})`}
        checked={allSelected}
        indeterminate={selectedIds.length > 0 && !allSelected}
        onChange={(e) => onChange(e.target.checked ? offers.map((offer) => offer.id) : [])}
      />
      <ul className="copy-offers-picker-list">
        {offers.map((offer) => (
          <li key={offer.id}>
            <Checkbox
              id={`copy-offer-${offer.id}`}
              checked={selectedIds.includes(offer.id)}
              onChange={(e) => toggleOffer(offer.id, e.target.checked)}
              label={<strong>{offer.artist_name || "No artist"}</strong>}
            />
            <div className="copy-offers-picker-details">
              <div>{dealType(offer)}</div>
              <div>{dealTerms(offer)}</div>
              <div>{STATE_LABELS[offer.state] || offer.state} - Created {offerDate(offer)}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

CopyOffersPicker.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    artist_name: PropTypes.string,
    state: PropTypes.string,
  })).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CopyOffersPicker;
